import { Col, Row } from 'react-bootstrap';
import { formatDateNz, GDD_THRESHOLD } from '../../utils';
import G3ForecastingChart from './G3ForecastingChart';

const G3Forecasting = ({ monitoringBlock, g3Model }) => {
  const dates = g3Model.SDATA || [];
  const gddAccumulation = g3Model.GDD_ACCUMULATION || [];

  const thresholdIndex = gddAccumulation.findIndex(
    (v) => Number(v) >= GDD_THRESHOLD
  );
  const cutoffDate =
    thresholdIndex > -1 ? dates[thresholdIndex] * 1000 : undefined;

  return (
    <Row>
      <Col>
        <G3ForecastingChart g3Model={g3Model} />
        <div className='mt-3'>
          <div>
            <b>Date GDD's satisfied:</b>{' '}
            {cutoffDate ? formatDateNz(cutoffDate) : 'N/A'}
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default G3Forecasting;

